
<template>
  <div>
    <NewPayment kind="bonus" @close="$router.push({ name: 'BonusPayments' })"></NewPayment>
  </div>
</template>

<script>

export default {
  name: 'NewBonusPayment',
  components: {
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
}
</script>
